import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EmployeeBranchLinkContainerModel } from "../../../../../../models/aggregates/erp/entity";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EmployeeBranchLinkingService extends BaseApiTemplateService<EmployeeBranchLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-employee-links/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-employee-links/backoffice-ep";
    this.httpClient = http;
  }

  public getByCustomCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        "branch-employee-links";
    }
    const UrlByCriteria =
      this.apiUrl + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
